module.exports = __webpack_public_path__ + "static/media/jinni.35521694.jpeg";